<template>
    <div>
        <x-modal
            :wWidth="1080"
            v-if="isVisible && page == 1"
            @cancel="requestThirdPartyPrivacyConsentModalClose"
            @close="requestThirdPartyPrivacyConsentModalClose"
            @ok="nextPage"
            :draggable="true"
            :resizable="true"
            :loading="loading"
            :okDisabled="formCheck"
            okText="Next Page">
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                Third Party Information
            </div>

            <div class="col-12 mt-3 mb-5" v-if="thirdPartyRecipient.length !== 0">
                <label for="team-referrers">Select Third Parties</label>
                <el-select class="w-100" v-model="selectedThirdPartyRecipient" multiple placeholder="Select"
                           value-key="id">
                    <el-option
                        v-for="item in thirdPartyRecipient"
                        :key="item.id"
                        :label="item.full_name"
                        :value="item"
                    >
                    </el-option>
                </el-select>
            </div>

            <el-divider v-if="thirdPartyRecipient.length !== 0">OR</el-divider>

            <el-alert
                type="error"
                v-show="thirdPartyErrors.length !== 0">
                {{ thirdPartyErrors }}
            </el-alert>

            <div class="col-12 mt-3">
                <el-row :gutter="10">
                    <el-col :span="24">
                        <el-form ref="setup" :model="thirdParty" label-position="top">
                            <el-row :gutter="10">
                                <el-col :span="12">
                                    <el-form-item label="First Name">
                                        <el-input type="text" v-model="thirdParty.first_name"
                                                  placeholder="First Name"></el-input>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="Last Name">
                                        <el-input type="text" v-model="thirdParty.last_name"
                                                  placeholder="Last Name"></el-input>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="Phone Number">
                                        <el-input v-model="thirdParty.phone"></el-input>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="12">
                                    <el-form-item label="Email Address">
                                        <el-input type="email" v-model="thirdParty.email"
                                                  placeholder="Email Address"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
        </x-modal>

        <x-modal
            :wWidth="1080"
            v-if="isVisible && page == 2"
            @cancel="requestThirdPartyPrivacyConsentModalClose"
            @close="requestThirdPartyPrivacyConsentModalClose"
            @ok="requestThirdPartyPrivacyConsentModalSubmit"
            :draggable="true"
            :resizable="true"
            :loading="loading"
            :okDisabled="requestPrivacyConsentModalButtonDisabled"
            okText="Request Consent"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                Request 3rd Party Privacy Consent
            </div>

            <div class="container">
                <el-form label-width="140px">

                    <email-sending-options></email-sending-options>

                    <email-recipients
                        v-if="emailBuilder.sendEmail || emailBuilder.sendSms"
                        :recipientType="recipientTypes"
                        :autoSelectType="recipientTypes"
                        :autoSelectRecipients="false"
                        :recipientAllowCreate="true"
                        :selectRecipients="formattedThirdPartyRecipient"
                        :hideCC="!emailBuilder.sendEmail ? true : false"
                        :hideBCC="!emailBuilder.sendEmail ? true : false"
                    ></email-recipients>

                    <email-task v-model="emailBuilder.task"></email-task>

                    <el-divider
                        v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"></el-divider>

                    <email-markup-multi
                        class="mb-3"
                        v-if="!_.isEmpty(emailBuilder.recipients) && (emailBuilder.sendEmail || emailBuilder.sendSms)"
                        action="third-party-privacy-consent"
                    ></email-markup-multi>
                </el-form>
            </div>
        </x-modal>
    </div>
</template>

<script>
import EmailSendingOptions from "@ambition/components/messages/EmailSendingOptions.vue"
import EmailRecipients from "@ambition/components/messages/EmailRecipients"
import EmailAttachments from "@ambition/components/messages/EmailAttachments"
import EmailMarkupMulti from "@ambition/components/messages/EmailMarkupMulti"
import EmailTask from "@ambition/components/messages/EmailTask"
import {mapGetters, mapState} from "vuex"
import XModal from "../../../../shared/components/modal/Modal";
import Multiselect from "vue-multiselect"

export default {
    name: "BuilderSendThirdPartyPrivacyConsentModal",
    props: {
        visible: {
            required: true,
            type: Boolean,
        },
        applicants: {
            type: Array,
        },
    },
    components: {
        XModal,
        EmailSendingOptions,
        EmailRecipients,
        EmailAttachments,
        EmailMarkupMulti,
        EmailTask,
        Multiselect
    },
    watch: {
        visible() {
            this.isVisible = this.visible
        },
    },
    data() {
        return {
            isVisible: false,
            loading: false,
            recipientTypes: ["other"],
            page: 1,
            thirdParty: {
                first_name: null,
                last_name: null,
                phone: null,
                email: null
            },
            thirdPartyData: [],
            thirdPartyRecipient: [],
            selectedThirdPartyRecipient: [],
            thirdPartyErrors: []
        }
    },
    mounted() {
        this.getThirdParty()
    },
    activated() {
    },
    computed: {
        ...mapGetters({
            emailBuilder: "builderEmail/getEmail",
            templatesLoaded: "builderEmail/checkTemplatesLoaded",
        }),
        requestPrivacyConsentModalButtonDisabled() {
            if (!this.emailBuilder.sendEmail) return false
            if (!this.templatesLoaded) return true
            if (this.emailBuilder.delaySending && !this.emailBuilder.sendAt) return true
            if (_.size(this.emailBuilder.recipients) >= 1 && !this.loading) return false
            return true
        },
        formCheck() {
            if (this.formattedThirdPartyRecipient.length !== 0) {
                return false
            } else {
                if (this.thirdPartyErrors.length !== 0) return true
            }
        },
        formattedThirdPartyRecipient() {
            this.loading = true
            let recipients = this.selectedThirdPartyRecipient
            let formEmail = this.thirdParty.email
            let thirdParty = []

            if (formEmail !== null) {
                thirdParty.push(formEmail)
            }

            if (recipients.length) {
                recipients.map(tp => thirdParty.push(tp.email))
            }

            this.loading = false

            return thirdParty
        },
    },
    methods: {
        getThirdParty() {
            this.loading = true
            const header = {
                headers: {Authorization: "Bearer " + this.$store.getters.token}
            }

            axios
                .get(
                    `/api/v2/applications/third-party?application_id=${this.$store.getters.initAppData.id}`,
                    header
                )
                .then((res) => {
                    this.thirdPartyRecipient = res.data
                })
                .catch((err) => {
                    console.error(err)
                    this.loading = false
                })

            this.loading = false
        },
        nextPage() {
            if (this.selectedThirdPartyRecipient.length && this.thirdParty.email == null && this.thirdParty.first_name == null && this.thirdParty.last_name == null && this.thirdParty.phone == null) {
                this.loading = false
                this.page = this.page + 1
            } else {
                this.loading = true
                const header = {
                    headers: {Authorization: "Bearer " + this.$store.getters.token}
                }

                axios
                    .post(
                        `/api/v2/applications/${this.$store.getters.initAppData.id}/third-party`,
                        {
                            ...this.thirdParty,
                            'application_id': this.$store.getters.initAppData.id
                        },
                        header
                    )
                    .then((res) => {
                        if (res.data && res.data.error) {
                            this.thirdPartyErrors = res.data.error
                            this.loading = false
                            this.page = 1
                        } else {
                            this.thirdPartyData = [`${res.data.email}`]
                            this.loading = false
                            this.page = this.page + 1
                        }
                    })
                    .catch((err) => {
                        this.thirdPartyErrors = err
                        this.loading = false
                        this.page = 1
                    })
            }
        },
        requestThirdPartyPrivacyConsentModalOpen() {
            this.$store.dispatch("builderEmail/resetEmail")
            this.loading = false
            this.isVisible = true
            this.page = 1
        },
        modalClose() {
            this.loading = false
            this.isVisible = false
            this.page = 1
        },
        requestThirdPartyPrivacyConsentModalClose() {
            this.$store.dispatch("builderEmail/resetEmail")
            this.loading = false
            this.isVisible = false
            this.page = 1
            this.$emit("update:visible", false)
        },
        requestThirdPartyPrivacyConsentModalSubmit() {
            this.loading = true
            if (this.emailBuilder.sendEmail || this.emailBuilder.sendSms) {
                const header = {
                    headers: {Authorization: "Bearer " + this.$store.getters.token}
                };
                axios
                    .patch(
                        `/api/v3/privacy-consent/${this.$store.getters.initAppData.id}`,
                        {
                            email: this.emailBuilder,
                            thirdParty: true,
                        },
                        header
                    )
                    .then((res) => {

                        // create application task
                        if (_.get(this.emailBuilder, "task.create", false)) {
                            this.$store.dispatch("statusIndicators/changeStatus", {
                                stage: "createTask",
                                token: this.$store.getters.token,
                                remindMe: this.$moment(this.emailBuilder.task.remindMe).format("YYYY-MM-DD"),
                                taskName: this.emailBuilder.task.name,
                                time: this.emailBuilder.task.time,
                                userId: this.emailBuilder.task.userId,
                                appId: this.$store.getters.initAppData.id,
                            })
                        }

                        // create recipient tasks
                        if (_.get(this.emailBuilder, "recipients", false)) {
                            this.emailBuilder.recipients.forEach((recipient) => {
                                if (_.get(recipient, "template.task.create", false)) {
                                    this.$store.dispatch("statusIndicators/changeStatus", {
                                        stage: "createTask",
                                        token: this.$store.getters.token,
                                        remindMe: this.$moment(recipient.template.task.remindMe).format("YYYY-MM-DD"),
                                        taskName: recipient.template.task.name,
                                        time: recipient.template.task.time,
                                        userId: recipient.template.task.userId,
                                        appId: this.$store.getters.initAppData.id,
                                    })
                                }
                            })
                        }

                        swal({
                            title: "Success",
                            type: "success",
                            text: "Privacy Consent Form Request Sent"
                        })

                        this.requestThirdPartyPrivacyConsentModalClose()
                    })
                    .catch((err) => {
                        console.error(err)
                        this.loading = false
                        Message({
                            message: "Request Failed",
                            type: "error",
                        })
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
    },
}
</script>
